import { createContext, useContext, useState } from "react";
import { STR } from "./strings";
import { SERVICES, FAQS, BLOG_POSTS, PORTFOLIO, FEATURES } from "../data/content";
import { SERVICES_ES, FAQS_ES, BLOG_POSTS_ES, PORTFOLIO_ES, FEATURES_ES } from "../data/content.es";

const LangContext = createContext(null);

const DATA = {
  en: { SERVICES, FAQS, BLOG_POSTS, PORTFOLIO, FEATURES },
  es: { SERVICES: SERVICES_ES, FAQS: FAQS_ES, BLOG_POSTS: BLOG_POSTS_ES, PORTFOLIO: PORTFOLIO_ES, FEATURES: FEATURES_ES }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sg-lang") || "en");

  const toggle = () => {
    const next = lang === "en" ? "es" : "en";
    setLang(next);
    localStorage.setItem("sg-lang", next);
    document.documentElement.lang = next;
  };

  return (
    <LangContext.Provider value={{ lang, toggle, t: STR[lang], data: DATA[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
